export default "__VITE_ASSET__BCMOEXNh__"